import User from '@/store/user';
export class RootStores {
  user = new User(this);
}

export default new RootStores();
